module.exports = __webpack_public_path__ + "img/2.f7b01f26.jpg";